import React, { Component } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import isNumber from 'lodash/isNumber';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { authConnect, UserProp } from 'auth';
import perms from 'auth/perms';
import DataProvider from 'api/data-provider';
import { InputListBox, InputLabel } from 'containers/form';
import Row from 'components/row';
import Button from 'components/button';
import AdSense from 'components/adsense';
import { OpenGraphImage } from 'components/image';

import Cards from './cards-object/cards';
import { dateLifeInfo } from './render-common';
import {
  renderBlockStocks, renderPurchaseOptions,
  renderMainInfo, getPartners, renderBlockComplaint, renderComplexYoutube
} from './content-project';
import {
  clickOutsideMapCardFunc,
  handleMarkerClickFunc,
  mapMarkerFunc, mapTileRendererFunc,
  renderBlockMap
} from './render-block-map';

import translates from './project-i18n';

import 'styles/domik/section-project/_page-project-objects.scss';

const bemClassesProject = new Bem('project');

@authConnect()
@I18nHoc(translates())
export default class Objects extends Component {
  static propTypes = {
    router: routerShape,
    params: PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ])
    }),
    project: PropTypes.shape({
      advanced_info: PropTypes.shape({})
    }),
    // objectsShort: PropTypes.arrayOf(PropTypes.shape({})),
    objectsPreloaded: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    landing: PropTypes.shape({
      data: PropTypes.shape({})
    }),
    seoData: PropTypes.shape({}),
    topic: PropTypes.string,
    objGroup: PropTypes.arrayOf(PropTypes.shape({})),
    currentTabId: PropTypes.number,
    isSensor: PropTypes.shape({}),
    auth: UserProp,
    checkPermission: PropTypes.func
  };

  static getDerivedStateFromProps(props, state) {
    const { params = {}, objGroup } = props;
    const type = get(params, 'landing.data.groupId');
    const objGroupInd = findIndex(objGroup, tab => get(tab,'data.groupId') === type);

    if (type !== state.type) {
      return {
        objClasses: false,
        objTerms: false,
        objGroupInd,
        type
      };
    }
    if (objGroupInd !== state.objGroupInd) {
      return { objGroupInd }
    }
    return null;
  }

  constructor(props, ctx) {
    super(props, ctx);

    this.project = 'domik';

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleObjGroupChange = this.handleObjGroupChange.bind(this);
    this.renderFiltersAndObj = this.renderFiltersAndObj.bind(this);
    this.renderFilter = this.renderFilter.bind(this);
    this.filterObjClassesChange = this.filterObjClassesChange.bind(this);
    this.filterObjTermsChange = this.filterObjTermsChange.bind(this);
    this.clearObjClasses = this.clearObjClasses.bind(this);
    // this.getStoreyText = this.getStoreyText.bind(this);

    this.mainDeveloperId = get(props, 'project.main_developer[0].id');

    this.state = {
      search: {},
      objClasses: false,
      objTerms: false,
      objGroupInd: 0
    };
  }

  mapMarker(point, latLng) { return mapMarkerFunc(point, latLng) }

  handleMarkerClick = (evt) => handleMarkerClickFunc.call(this, evt);

  clickOutsideMapCard = (evt) => clickOutsideMapCardFunc.call(this, evt);

  mapTileRenderer = payload => mapTileRendererFunc.call(this, payload);

  /*
  getStoreyText(storeyFrom, storeyTo) {
    let storeyText = 'Все этажи';

    if (storeyFrom && storeyTo) {
      return storeyText = `от ${storeyFrom} до ${storeyTo}`;
    }

    if (storeyFrom) {
      return storeyText = `Этаж от ${storeyFrom}`;
    }

    if (storeyTo) {
      return storeyText = `Этаж до ${storeyTo}`;
    }

    return storeyText;
  }
  */

  handleSearchChange(data) {
    this.setState({
      search: data,
    });
  }

  handleObjGroupChange(data) {
    const { objGroup, router } = this.props;
    const pathname = objGroup[data].url;

    router.replace({ pathname });
  }

  clearObjClasses() {
    const { objGroup, router } = this.props;
    const objGroupInd = get(this, 'state.objGroupInd');
    const pathname = objGroup[objGroupInd] ? objGroup[objGroupInd].url : null;
    this.filterObjClassesChange();

    router.replace({ pathname });
  }

  filterObjClassesChange(data) {
    if (this.state.objClasses !== data) {
      this.setState({
        objClasses: data,
      });
    }
  }

  filterObjTermsChange(data) {
    if (this.state.objTerms !== data && isNumber(data)) {
      this.setState({
        objTerms: data,
      });
    }
    if (!isNumber(data)) {
      this.setState({
        objTerms: null,
      });
    }
  }

  classesFilter(data) {
    const { i18n } = this;
    const { type } = this.state;
    const sortData = sortBy(data, item => get(item, 'classesDict.sort_order'));
    const sortedObj = [];
    map(sortData, (val) => {
      const index = type === 'comm' ?
        findIndex(sortedObj, item => get(val, 'type') === get(item, 'type')) :
        findIndex(sortedObj, item => get(val, 'classesDict.id') === get(item, 'classesDict.id'));
      if (index === -1) sortedObj.push(val);
    });
    // if (sortedObj.length <= 1) return null;
    const label = type === 'flats' ? i18n('rooms') : i18n('type');
    const isSelectObjClasses = this.state.objClasses === undefined;

    return (
      <div {...bemClassesProject('row', 'table')}>
        <div{...bemClassesProject('item', 'colLabel')}>
          <InputLabel
            {...bemClassesProject('text', 'label')}
            schema={{ label }}
            horizontal
          />
        </div>
        <div{...bemClassesProject('item', 'colInfo')}>
          <Button
            {...bemClassesProject('btn', { listbox: true, active: isSelectObjClasses })}
            onClick={this.clearObjClasses}
            label={i18n('btnAllText')}
          />
          <InputListBox
            listBoxItems={map(sortedObj, (val) => {
              let value = get(val, 'type_dict.entity_long');
              if (type === 'flats') value = val.classesDict.abbrev;
              if (type === 'houses') value = val.classes || get(val, 'type_dict.entity_long');
              if (
                type === 'garage' ||
                type === 'lands'
              ) value = val.classesDict.value_long;
              return ({
                id: value,
                value
              });
            }
            )}
            nullValueItem={false}
            onChange={this.filterObjClassesChange}
            value={this.state.objClasses}
            horizontal
            noError
          />
        </div>
      </div>
    );
  }

  termsFilter(data) {
    const { i18n } = this;
    const sortByQuartet = sortBy(data, item => get(item, 'house_properties.built_quarter'));
    const sortByYear = sortBy(sortByQuartet, item => get(item, 'house_properties.built_year'));
    let termsId = -1;
    this.termsArray = [];

    map(sortByYear, (val) => {
      const house_status_ready = get(val, 'house_properties.house_status_ready');
      if (this.termsArray.length === 0 && house_status_ready) {
        termsId += 1;
        this.termsArray.push({ id: termsId, value: i18n('readyText') });
      }
    });
    let isCurrentQuarterAdded = false;
    map(sortByYear, (val) => {
      const house_status_ready = get(val, 'house_properties.house_status_ready');
      const built_year = get(val, 'house_properties.built_year');
      const built_quarter = get(val, 'house_properties.built_quarter');

      if (house_status_ready || !built_year || !built_quarter) return;

      const nowYear = new Date().getFullYear();
      const nowMoth = new Date().getMonth();
      const nowQuarter = Math.floor(nowMoth / 3) + 1;
      const isFuture = built_year > nowYear || (built_year === nowYear && built_quarter > nowQuarter);
      const isPastAndCurrent = built_year < nowYear || (built_year === nowYear && built_quarter <= nowQuarter);

      if (isFuture) {
        const index = findIndex(this.termsArray, { built_year, built_quarter });

        if (index === -1) {
          termsId += 1;
          this.termsArray.push({
            id: termsId,
            built_quarter,
            built_year,
            value: `${built_quarter} кв ${built_year}`
          });
        }
      }

      if (isPastAndCurrent && !isCurrentQuarterAdded) {
        termsId += 1;
        isCurrentQuarterAdded = true;
        this.termsArray.push({
          id: termsId,
          built_quarter: nowQuarter,
          built_year: nowYear,
          value: `${nowQuarter} кв ${nowYear}`
        });
      }
    });

    if (this.termsArray.length === 0) return null;
    const isSelectObjTerms = this.state.objTerms === null;

    return (
      <div {...bemClassesProject('row', 'table')}>
        <div{...bemClassesProject('item', 'colLabel')}>
          <InputLabel
            {...bemClassesProject('text', 'label')}
            schema={{ label: i18n('commissioning') }}
            horizontal
          />
        </div>
        <div{...bemClassesProject('item', 'colInfo')}>
          <Button
            {...bemClassesProject('btn', { listbox: true, active: isSelectObjTerms })}
            onClick={this.filterObjTermsChange}
            label={i18n('btnAnyTimeText')}
          />
          <InputListBox
            listBoxItems={map(
              this.termsArray, val => ({
                id: val.id,
                value: val.value
              })
            )}
            nullValueItem={false}
            onChange={this.filterObjTermsChange}
            value={this.state.objTerms}
            horizontal
            noError
          />
        </div>
      </div>
    );
  }

  renderFiltersAndObj({ data }) {
    const { project = {}, seoData, checkPermission } = this.props;
    const seoObjectsTypeHeader = get(seoData, 'objectsTypeHeader');
    const { all_flats_sold, all_commercial_sold, all_house_and_area_sold } = project;
    const soldData = { all_flats_sold, all_commercial_sold, all_house_and_area_sold };
    const permObjManage = checkPermission(perms.OBJECT_MANAGE_ALL_NEWBUILD_OBJECTS);

    return (
      <>
        {this.renderFilter(data)}
        <Cards
          data={data}
          projectData={project}
          type={this.state.type}
          soldData={soldData}
          objClasses={this.state.objClasses}
          objTerms={this.state.objTerms}
          termsArray={this.termsArray}
          seoHeader={seoObjectsTypeHeader}
          permObjManage={permObjManage}
        />
      </>
    );
  }

  renderFilter(data) {
    return (
      <div {...bemClassesProject('formFilter', 'filter')}>
        {this.classesFilter(data)}
        {this.termsFilter(data)}
      </div>
    );
  }

  render() {
    const {
      project, objectsPreloaded, landing, params = {}, creators, renderAskQuestion, topic
    } = this.props;
    const url = get(landing, 'url', '');
    const urlComplaint = url;
    const landingVal = get(landing, 'data.value', {});
    const type = get(landing, 'params.obj.type');
    const groupName =
      get(landing, 'data.value.groupName') ||
      get(landing, 'data.value.value_short') ||
      get(landing, 'data.value.entity_long');
    const dateLife = get(project, 'date_life');
    const id = get(project, 'id');
    const imageId = get(project, 'title_image.id');
    const { advanced_info = {}, display_path, location_path, title_image, status_ready, ...rest
    } = project;
    const propsGroup = { ...advanced_info, ...rest };
    const { landingParams } = params;
    const partners = getPartners.call(this, this.mainDeveloperId, creators);

    return (
      <>
        <LazyHydrate ssrOnly>
          <OpenGraphImage imageId={imageId} />
        </LazyHydrate>
        <div {...bemClassesProject('title')}>
          <div {...bemClassesProject('text')}><h1 children={topic} /></div>
        </div>
        <DataProvider
          url="domik/objects/newbuild-objects"
          preloaded={objectsPreloaded}
          query={{
            complex_id: id,
            priceCurrency: 'uah',
            type,
            ...landingVal.query,
            ...this.state.search,
          }}
          queryJson
          renderer={this.renderFiltersAndObj}
        />
        <div {...bemClassesProject('plansList')}>
          <div
            {...bemClassesProject('dateLifeInfo')}
            children={dateLifeInfo.call(this, bemClassesProject, dateLife, groupName)}
          />
          <Row {...bemClassesProject('row', 'purchaseOptionsRow')}>
            {renderPurchaseOptions.call(this, propsGroup)}
            {renderBlockStocks.call(this, rest.stocks_array, propsGroup)}
          </Row>
        </div>
        {renderBlockComplaint.call(this, id, urlComplaint, bemClassesProject)}
        {renderComplexYoutube.call(this, bemClassesProject)}
        <div {...bemClassesProject('block', 'info horizontal')}>
          {renderMainInfo.call(this)}
          {partners}
        </div>
        <LazyHydrate whenVisible>
          {renderBlockMap.call(this, project, landingParams)}
        </LazyHydrate>
        <AdSense {...bemClassesProject('blockAdSense')} />
        {renderAskQuestion(id, project, url)}
      </>
    );
  }
}
